import {AxiosError} from 'axios';
import {GET_NON_NATIONAL_RESULTS_FILES_CONFIG_URL} from '../../constants/apiUrls';
import {GET_APPLICATION_FILES_CONFIG_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface NonNationalResultsFilesConfigResponse {
  fileSizeLimit: number;
  fileNumLimit: number;
  uploadFileTypes: string[];
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: NonNationalResultsFilesConfigResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalResultsFileConfig = ({
                                                     onSuccess,
                                                     onError,
                                                   }: Input) => {
  const getApplicationFilesConfigPassportPhoto = async () => {
    const res = await axiosClient.get<NonNationalResultsFilesConfigResponse>(
        GET_NON_NATIONAL_RESULTS_FILES_CONFIG_URL()
    );
    return res.data;
  };

  return useCustomQuery(
      [GET_APPLICATION_FILES_CONFIG_QUERY_KEY],
      getApplicationFilesConfigPassportPhoto,
      {
        onSuccess,
        onError,
      }
  );
};
